module.exports = __webpack_public_path__ + "img/ico_biaoqianziyuan.e7b67a6f.png";